var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-box"},[(_vm.close)?_c('i',{staticClass:"member-box__close el-icon-close",on:{"click":function($event){return _vm.$emit('closePanel')}}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }